import { Box, Grid, LinearProgress, linearProgressClasses, Modal, styled } from '@mui/material';

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[2],
  borderRadius: '2px',
  backgroundColor: theme.palette.background.paper,
  height: 'fit-content',
  maxHeight: '95vh',
  overflowY: 'auto',
  width: '600px',
  position: 'sticky',
  marginRight: '10px',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    maxWidth: '100vw',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'auto',
    maxHeight: '98dvh',
    left: '10px',
  },
  scrollbarWidth: 'none',
}));

export const StyledModal = styled(Modal)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  '&:focus': {
    outline: 'none',
  },
}));

export const RowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  width: '100%',
  overflow: 'auto',
}));

export const ColContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  overflow: 'auto',
  height: 'fit-content',
  justifyContent: 'space-between',
}));

export const FormSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const ProjectListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexGrow: 2,
  height: '95vh',
  maxWidth: '95wh',
  padding: theme.spacing(2),
  overflow: 'auto',
  [theme.breakpoints.down('sm')]: {
    // marginTop: theme.spacing(2),
    height: '100%',
  },
}));

export const ProjectItemGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  maxHeight: '64px',
  borderRadius: '2px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  ':hover': {
    backgroundColor: theme.palette.primary.contrastText,
    cursor: 'pointer',
  },
}));

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.busmanColors.lightGrey,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.busmanColors.busmanPrimary,
  },
}));
